module.exports = __webpack_public_path__ + "static/media/3_fruit_cupcake_small.80e782bb.jpg";